export default __webpack_public_path__ + "static/media/menu.423dabf2.png";